module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sponsor flex-container"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Sponsors")]), _vm._v(" "), _vm._l((_vm.records), function(sponsor) {
    return (sponsor['商標png'] !== undefined) ? _c('span', {
      key: sponsor.id
    }, [_c('a', {
      attrs: {
        "href": sponsor['URL'],
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "logo",
      attrs: {
        "src": sponsor['商標png'][0].thumbnails.small.url,
        "alt": sponsor['贊助商']
      }
    })])]) : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e7af362"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sponsor.vue
// module id = 961
// module chunks = 1